import type { ReactNode } from "react";
import { CompactSelect } from "../../../../../../../../../../shared/components/selects/compact-select/CompactSelect";
import { CompactButton } from "../../../../../../../../../../shared/components/buttons/compact-button/CompactButton";

export type CatalogSelectItem = { key: string; node: ReactNode };

type Props = {
	title: string;
	availableItems: CatalogSelectItem[];
	selectedItems: CatalogSelectItem[];
	onSelect: (key: string) => void;
	onRemove: (key: string) => void;
	isLoading?: boolean;
	// Якщо задано — селект вимкнено, коли в списку лише цей службовий пункт (напр. «усі країни»).
	sentinelKey?: string;
};

export const CatalogMultiSelectField = ({
	title,
	availableItems,
	selectedItems,
	onSelect,
	onRemove,
	isLoading = false,
	sentinelKey,
}: Props) => {
	const showPlaceholderAsSelected =
		selectedItems.length === 0 &&
		sentinelKey != null &&
		availableItems.some((i) => i.key === sentinelKey);

	const selectDisabled =
		availableItems.length === 0 ||
		(sentinelKey != null &&
			availableItems.length === 1 &&
			availableItems[0].key === sentinelKey);

	return (
		<div className='form__fields_field-item field-item'>
			<div className='field-item__title'>{title}</div>
			<div className='field-item__input-wrapper'>
				<CompactSelect
					items={availableItems}
					onSelect={onSelect}
					value={showPlaceholderAsSelected ? sentinelKey : undefined}
					suppressListActiveHighlight={selectedItems.length > 0}
					className={"field-item__select"}
					isLoading={isLoading}
					disabled={selectDisabled}
					usePortal
				/>
			</div>
			{selectedItems.length > 0 && (
				<div className='field-item__added-items-wrapper'>
					{selectedItems.map((item) => (
						<div key={item.key} className='added-item'>
							<div className='added-item__name'>{item.node}</div>
							<div
								className='added-item__remove-button'
								onClick={() => onRemove(item.key)}>
								<img src='/img/icons/close.png' alt='delete' />
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
};
